export class RestoreGoogleWorkspaceGroupRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "workloads",
            "baseName": "workloads",
            "type": "Array<GoogleWorkspaceGroupRestoreWorkload>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceGroupRequest.attributeTypeMap;
    }
    constructor() {
    }
}
